// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ksJL","tabsBox":"styles_tabsBox__4Nh1Z","createButton":"styles_createButton__37xne"};